import type { $ } from "../../../dom";
import {
  SimpleCheckboxGroupInput,
  type SimpleCheckboxGroupInputOptions,
} from "../simple";
import { WebflowCheckboxInput } from "./webflow-checkbox-input";

export type WebflowCheckboxGroupInputOptions = Omit<
  SimpleCheckboxGroupInputOptions,
  "instantiateInputs"
> & {};

export class WebflowCheckboxGroupInput extends SimpleCheckboxGroupInput {
  public declare inputs: WebflowCheckboxInput[];

  constructor($root: $, options: WebflowCheckboxGroupInputOptions = {}) {
    const { ...superOptions } = options;

    super($root, {
      instantiateInputs: ($root) =>
        $root
          .find(".w-checkbox")
          .map((element) => new WebflowCheckboxInput($root.make(element))),
      ...superOptions,
    });
  }
}
